import instance from "./instance";
import {API_URL} from "../config/api";
import {getDriveTypeFix} from "./help";

export default class FileService {


    static delete = async (path, driveType) => {
        // console.log("delete-path", path);
        const res = await instance.delete(API_URL.DRIVE_FILE + getDriveTypeFix(driveType) + '/' + encodeURIComponent(path));
        // console.log(res);
        try {
            if (res.status === 200) {
                return true;
            }
        } catch (e) {
            console.error(e);
        }
    }
    static copy = async ({file_name, file_name_new, move, driveType}) => {
        const res = await instance.put(API_URL.DRIVE_FILE + getDriveTypeFix(driveType) + '/copy', {file_name, file_name_new, move});
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }
    static checkFile = async (postData, driveType) => {
        const res = await instance.post(API_URL.DRIVE_FILE + getDriveTypeFix(driveType), postData);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }

    }
    static rename = async ({file_name, file_name_new, driveType}) => {

        const res = await instance.patch(API_URL.DRIVE_FILE + getDriveTypeFix(driveType), {file_name, file_name_new});
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }
    static getDownLoadLink = async (parent, file, driveType) => {
        const path = parent && parent !== "/" ? parent + "/" + file : file;
        // console.log("before-encode", path);
        // console.log("after-encode", encodeURIComponent(path));
        // console.log("driveType", driveType);
        const url = API_URL.DRIVE_FILE+ ((driveType && driveType.length>0) ? `/${driveType}` : "") + "/"  + encodeURIComponent(path);
        const res = await instance.get(url);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }
    static uncompress = async (postData, driveType) => {
        const res = await instance.post(API_URL.DRIVE_FILE + ((driveType && driveType.length>0) ? `/${driveType}` : "") + '/uncompress', postData);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }
}